module.exports = __webpack_public_path__ + "c3133bbfc3b656ba16f1fc031ae75182.MP3";